import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function ProtectedRoute({ children }: { children: any }) {
  const auth = useAuth();
  const location = useLocation();
  if (auth.loading) return <div className="center-screen">Chargement d’EDUVERSA…</div>;
  if (!auth.principal) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}
